export default __webpack_public_path__ + "static/media/logo-ccb-3.9c29d5a8.png";